import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Image, Table } from 'react-bootstrap';
import { isArray } from 'lodash';
import { getOrgTermsContent } from '../../../../content/utils.js';
import NotesIcon from '../../../icons/NotesIcon.jsx';
import { TemplateViewLink } from '../../../links/index.jsx';
import { InfoModal } from '../../../modals/InfoModal.jsx';
import ChangeInsightTemplateActionDropdown from './ChangeInsightTempleateActionDropdown/ChangeInsightTemplateActionDropdown.jsx';
import styles from './CustomSurveyTemplatesTable.module.css';

const CustomSurveyTemplatesTableRow = (
  surveyTemplate,
  onShowModal,
  initiativeType,
  index,
  setShowInfoModal,
  checkAuthorize
) => (
  <tr
    key={`${surveyTemplate.title}${surveyTemplate.id}`}
    style={{ width: '100%' }}
  >
    <td style={{ width: '30%', paddingLeft: '74px' }}>
      <TemplateViewLink templateId={surveyTemplate.id}>
        <a>
          <h3>{surveyTemplate.title}</h3>
        </a>
      </TemplateViewLink>
    </td>
    <td style={{ width: '5%' }}>
      <strong>{surveyTemplate.projectsCount}</strong>
    </td>
    <td style={{ width: '5%' }}>
      <strong>{surveyTemplate.initiativesCount}</strong>
    </td>
    <td style={{ width: '5%' }}>
      {surveyTemplate.description ? (
        <button
          type="button"
          className="btn-clear bg-transparent flex flex-center"
          onClick={() => setShowInfoModal(surveyTemplate.description)}
        >
          <NotesIcon />
        </button>
      ) : (
        '—'
      )}
    </td>
    <td style={{ width: '5%' }}>
      <strong className={`bordered-muted ${surveyTemplate.status}`}>
        {surveyTemplate.status ? surveyTemplate.status : '—'}
      </strong>
    </td>
    <td style={{ width: '15%' }}>
      {surveyTemplate.creatorData ? (
        <div className="flex">
          <Image
            alt={surveyTemplate.creatorData.createdBy}
            className="author-avatar m-r-8"
            src={surveyTemplate.creatorData.avatar}
            responsive
          />
          <strong>{surveyTemplate.creatorData.fullName}</strong>
        </div>
      ) : (
        <div className="flex">
          <Image
            alt="system-template"
            className="author-avatar m-r-8"
            src="/static/images/system-logo.png"
            responsive
          />
          <strong>System</strong>
        </div>
      )}
    </td>
    <td style={{ width: '10%' }}>
      {moment(surveyTemplate.lastEditedAt).format('MM/DD/YYYY')}
    </td>
    <td>
      <div className="flex" style={{ justifyContent: 'end' }}>
        <TemplateViewLink templateId={surveyTemplate.id}>
          <Button bsStyle="primary" className="m-r-8">
            View
          </Button>
        </TemplateViewLink>
        {checkAuthorize ? (
          <ChangeInsightTemplateActionDropdown
            surveyTemplate={surveyTemplate}
          />
        ) : null}
      </div>
    </td>
  </tr>
);

const CustomSurveyTemplatesTable = ({
  surveyTemplates,
  onShowModal,
  initiativeType,
  checkAuthorize,
}) => {
  const [showInfoModal, setShowInfoModal] = useState(false);
  return (
    <Table hover className={styles.customSurveyTemplatesTable}>
      <thead>
        <tr style={{ width: '100%' }}>
          <th style={{ width: '30%', paddingLeft: '74px' }}>Title</th>
          <th style={{ width: '5%' }}>{getOrgTermsContent('projects')}</th>
          <th style={{ width: '5%' }}>{getOrgTermsContent('initiatives')}</th>
          <th style={{ width: '5%' }}>Description</th>
          <th style={{ width: '10%' }}>Status</th>
          <th style={{ width: '15%' }}>Created By</th>
          <th style={{ width: '10%' }}>Last Edited</th>
          <th className="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        {isArray(surveyTemplates)
          ? surveyTemplates.map((template, index) =>
              CustomSurveyTemplatesTableRow(
                template,
                onShowModal,
                initiativeType,
                index,
                setShowInfoModal,
                checkAuthorize
              )
            )
          : null}
        <InfoModal
          show={showInfoModal}
          onHide={() => setShowInfoModal(null)}
          title="Description"
          message={showInfoModal}
          isActionBtn={false}
        />
      </tbody>
    </Table>
  );
};

CustomSurveyTemplatesTable.propTypes = {
  surveyTemplates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      externalId: PropTypes.number.isRequired,
      initiativeType: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default CustomSurveyTemplatesTable;
